<div class="wrapper">
    @if (question$ | async; as question) {
    <div [ngClass]="eq5dCompliant ? 'content-eq5d' : 'content'">
        <app-paragraph
            class="text-left"
            [ngClass]="{
                'm-top':
                    eq5dCompliant &&
                    !!question?.answerSettings?.values?.range?.maxValueLabel
            }"
            [text]="question.text"
        ></app-paragraph>
        @if (convertedAnswerSetting$ | async; as answerSettings) {
        <app-dynamic-form
            [answers]="answerSettings"
            [questionId]="question.id"
            [nextButton]="{
                disabled: false,
                type: 'filledPrimary',
                icon_name: 'navigate_next',
                isWhiteIcon: true,
                isOutlined: true,
                isIconAfterLabel: true,
                isIconBeforeLabel: false,
                text: nextQuestionText
            }"
            [backButton]="{
                disabled: !screen.previousScreenId,
                type: 'outlinedPrimary',
                icon_name: 'navigate_before',
                isWhiteIcon: true,
                isOutlined: false,
                isIconBeforeLabel: true,
                text: previousQuestionText
            }"
            (navigateBack)="handleNavigateBack($event)"
            (submitting)="handleSubmit($event)"
        ></app-dynamic-form>
        }
    </div>
    }
</div>
